(function(){
  function initBackTop(){
    var top = document.querySelector('.lovendi-top');
    if(!top){
      top = document.createElement('button');
      top.className = 'lovendi-top';
      top.type = 'button';
      top.setAttribute('aria-label','Przewiń do góry');
      top.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
      document.body.appendChild(top);
      top.addEventListener('click',function(){ window.scrollTo({top:0,behavior:'smooth'}); });
    }
    function onScroll(){ top.classList.toggle('is-visible', window.scrollY > 600); }
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }

  function initSticky(){
    var sticky = document.querySelector('.lovendi-sticky');
    if(!sticky) return;
    sticky.classList.remove('is-visible');
    var anchor = document.querySelector('.lovendi-builder__add') || document.querySelector('.lovendi-builder') || document.querySelector('.product-form__submit');
    var target = document.querySelector('.lovendi-builder') || document.querySelector('#MainContent');
    var link = sticky.querySelector('a');
    if(link && target){
      link.addEventListener('click', function(e){ e.preventDefault(); target.scrollIntoView({behavior:'smooth', block:'center'}); });
    }
    if(!anchor) return;
    function upd(){
      var r = anchor.getBoundingClientRect();
      sticky.classList.toggle('is-visible', r.bottom <= 0);
    }
    window.addEventListener('scroll', upd, {passive:true});
    window.addEventListener('resize', upd, {passive:true});
    window.addEventListener('load', upd);
    setTimeout(upd, 400);
    upd();
  }

  function initPayUnderAtc(){
    var wrap = document.querySelector('.product-form__buttons');
    if(!wrap || document.querySelector('.lovendi-atc-pay')) return;
    var row = document.createElement('div');
    row.className = 'lovendi-atc-pay';
    row.innerHTML = '<span class="lovendi-atc-pay__safe"><svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg> Bezpieczna płatność</span><span class="lovendi-atc-pay__badges"><span>BLIK</span><span>Przelewy24</span><span>Visa</span><span>Mastercard</span><span>Apple Pay</span><span>Google Pay</span></span>';
    wrap.parentNode.insertBefore(row, wrap.nextSibling);
  }

  function initDelivery(){
    var els = document.querySelectorAll('[data-lovendi-deliver]');
    if(!els.length) return;
    var d = new Date(), added = 0;
    while(added < 2){ d.setDate(d.getDate()+1); var dow = d.getDay(); if(dow !== 0 && dow !== 6) added++; }
    var days = ['niedziela','poniedziałek','wtorek','środa','czwartek','piątek','sobota'];
    var months = ['stycznia','lutego','marca','kwietnia','maja','czerwca','lipca','sierpnia','września','października','listopada','grudnia'];
    var txt = days[d.getDay()] + ', ' + d.getDate() + ' ' + months[d.getMonth()];
    els.forEach(function(e){ e.textContent = txt; });
  }

  function initBaSlider(){
    document.querySelectorAll('.lovendi-baslider').forEach(function(s){
      var after = s.querySelector('.lovendi-baslider__after');
      var handle = s.querySelector('.lovendi-baslider__handle');
      if(!after || !handle) return;
      var dragging = false;
      function set(clientX){
        var r = s.getBoundingClientRect();
        if(!r.width) return;
        var p = (clientX - r.left) / r.width;
        p = Math.max(0, Math.min(1, p));
        after.style.clipPath = 'inset(0 ' + ((1 - p) * 100) + '% 0 0)';
        handle.style.left = (p * 100) + '%';
      }
      function start(e){
        dragging = true;
        s.classList.add('is-dragging');
        if(e.pointerId != null && s.setPointerCapture){ try{ s.setPointerCapture(e.pointerId); }catch(_){} }
        set(e.clientX);
      }
      function move(e){
        if(!dragging) return;
        if(e.cancelable && e.pointerType && e.pointerType !== 'mouse') e.preventDefault();
        set(e.clientX);
      }
      function end(){ dragging = false; s.classList.remove('is-dragging'); }

      if(window.PointerEvent){
        s.addEventListener('pointerdown', start);
        s.addEventListener('pointermove', move);
        s.addEventListener('pointerup', end);
        s.addEventListener('pointercancel', end);
        s.addEventListener('lostpointercapture', end);
      } else {
        s.addEventListener('mousedown', function(e){ dragging = true; set(e.clientX); });
        window.addEventListener('mousemove', function(e){ if(dragging) set(e.clientX); });
        window.addEventListener('mouseup', end);
        s.addEventListener('touchstart', function(e){ dragging = true; set(e.touches[0].clientX); }, {passive:true});
        s.addEventListener('touchmove', function(e){ if(dragging) set(e.touches[0].clientX); }, {passive:true});
        s.addEventListener('touchend', end);
      }
    });
  }

  function initBuilder(){
    document.querySelectorAll('.lovendi-builder').forEach(function(b){
      var variants, prices, single;
      try{ variants = JSON.parse(b.dataset.variants); }catch(e){ variants = {}; }
      try{ prices = JSON.parse(b.dataset.prices); }catch(e){ prices = {}; }
      single = parseInt(b.dataset.single, 10) || 0;
      var sizes = Object.keys(variants);
      if(!sizes.length) return;
      var qtyBtns = b.querySelectorAll('.lovendi-builder__qtybtn');
      var slots = b.querySelector('.lovendi-builder__slots');
      var priceEl = b.querySelector('.lovendi-builder__price');
      var addBtn = b.querySelector('.lovendi-builder__add');
      var errEl = b.querySelector('.lovendi-builder__err');
      var qty = 1;
      function money(gr){ return (gr/100).toFixed(2).replace('.', ',') + ' zł'; }
      function tagFor(q){ var p = prices[q] || single*q; return money(Math.round(p/q)) + '/szt'; }
      b.querySelectorAll('[data-lvb-tag]').forEach(function(sp, i){
        var q = i+1; var base = tagFor(q);
        if(sp.textContent.trim() !== ''){ sp.textContent = base + ' · ' + sp.textContent.trim(); }
        else { sp.textContent = base; }
      });
      function renderSlots(){
        slots.innerHTML = '';
        for(var i=0;i<qty;i++){
          var row = document.createElement('div'); row.className = 'lovendi-builder__slot';
          var lab = document.createElement('span'); lab.className = 'lovendi-builder__slotlab'; lab.textContent = 'Sztuka ' + (i+1) + ' — rozmiar';
          var sel = document.createElement('div'); sel.className = 'lovendi-builder__sizes';
          sizes.forEach(function(sz, idx){
            var btn = document.createElement('button'); btn.type = 'button';
            btn.className = 'lovendi-builder__size' + (idx===0 ? ' is-active' : '');
            btn.textContent = sz; btn.setAttribute('data-size', sz);
            btn.addEventListener('click', function(){
              var par = this.parentNode;
              par.querySelectorAll('.lovendi-builder__size').forEach(function(x){ x.classList.remove('is-active'); });
              this.classList.add('is-active');
            });
            sel.appendChild(btn);
          });
          row.appendChild(lab); row.appendChild(sel); slots.appendChild(row);
        }
      }
      function updPrice(){
        var pack = prices[qty] || single*qty;
        var full = single*qty;
        var per = Math.round(pack/qty);
        var html = '<span class="lovendi-builder__now">' + money(pack) + '</span> <span class="lovendi-builder__per">(' + money(per) + '/szt)</span>';
        if(full > pack){ html += '<span class="lovendi-builder__save">Taniej o ' + money(full-pack) + ' niż osobno</span>'; }
        priceEl.innerHTML = html;
      }
      qtyBtns.forEach(function(btn){
        btn.addEventListener('click', function(){
          qty = parseInt(btn.dataset.q, 10) || 1;
          qtyBtns.forEach(function(x){ x.classList.remove('is-active'); });
          btn.classList.add('is-active');
          renderSlots(); updPrice();
        });
      });
      function openDrawer(state){
        try{
          if(state && state.sections){
            var cd = document.querySelector('cart-drawer');
            if(cd && state.sections['cart-drawer']){
              var doc = new DOMParser().parseFromString(state.sections['cart-drawer'], 'text/html');
              var ni = doc.querySelector('.drawer__inner'); var ci = cd.querySelector('.drawer__inner');
              if(ni && ci){ ci.innerHTML = ni.innerHTML; }
              cd.classList.remove('is-empty');
              if(typeof cd.open === 'function'){ cd.open(); }
              else { document.body.classList.add('overflow-hidden'); cd.setAttribute('open',''); cd.classList.add('active','animate'); }
            }
            if(state.sections['cart-icon-bubble']){
              var cib = document.getElementById('cart-icon-bubble');
              if(cib){ var d2 = new DOMParser().parseFromString(state.sections['cart-icon-bubble'], 'text/html'); var nb = d2.querySelector('#cart-icon-bubble'); if(nb) cib.innerHTML = nb.innerHTML; }
            }
            return;
          }
        }catch(e){}
        window.location.href = '/cart';
      }
      addBtn.addEventListener('click', function(){
        errEl.hidden = true;
        var counts = {};
        b.querySelectorAll('.lovendi-builder__slot').forEach(function(row){
          var act = row.querySelector('.lovendi-builder__size.is-active');
          var sz = act ? act.getAttribute('data-size') : sizes[0];
          counts[sz] = (counts[sz]||0) + 1;
        });
        var items = [];
        Object.keys(counts).forEach(function(sz){ if(variants[sz]) items.push({id: variants[sz], quantity: counts[sz]}); });
        if(!items.length) return;
        addBtn.disabled = true; addBtn.classList.add('is-loading');
        fetch('/cart/add.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({items: items, sections: ['cart-drawer','cart-icon-bubble'], sections_url: window.location.pathname})})
          .then(function(r){ if(!r.ok) throw new Error('add'); return r.json(); })
          .then(function(state){ openDrawer(state); })
          .catch(function(){ errEl.textContent = 'Nie udało się dodać do koszyka. Spróbuj ponownie.'; errEl.hidden = false; })
          .then(function(){ addBtn.disabled = false; addBtn.classList.remove('is-loading'); });
      });
      renderSlots(); updPrice();
    });
  }

  function initTabs(){
    document.querySelectorAll('.lovendi-tabs').forEach(function(t){
      var btns = t.querySelectorAll('.lovendi-tabs__btn');
      var panes = t.querySelectorAll('.lovendi-tabs__pane');
      btns.forEach(function(b, i){
        b.addEventListener('click', function(){
          btns.forEach(function(x){ x.classList.remove('is-active'); });
          panes.forEach(function(x){ x.classList.remove('is-active'); });
          b.classList.add('is-active');
          if(panes[i]) panes[i].classList.add('is-active');
        });
      });
    });
  }

  function initRating(){
    var holder = document.querySelector('.lovendi-bbrating');
    if(!holder) return;
    var txt = holder.getAttribute('data-text') || '';
    var title = document.querySelector('.product__title');
    if(!title) return;
    if(document.querySelector('.lovendi-bbrating-live')) return;
    var node = document.createElement('div');
    node.className = 'lovendi-bbrating-live';
    node.innerHTML = '<span class="lovendi-bbrating-live__stars" aria-hidden="true">★★★★★</span>' +
      (txt ? '<span class="lovendi-bbrating-live__text"></span>' : '');
    if(txt){ node.querySelector('.lovendi-bbrating-live__text').textContent = txt; }
    title.parentNode.insertBefore(node, title);
  }

  function initCartExtras(){
    var drawer = document.querySelector('cart-drawer');
    if(!drawer) return;
    var THRESHOLD = 12999;
    function money(gr){ return (gr/100).toFixed(2).replace('.', ',') + ' zł'; }
    function renderBar(cart){
      var contents = drawer.querySelector('.drawer__contents') || drawer.querySelector('#CartDrawer-CartItems');
      if(!contents || !cart || cart.item_count === 0) return;
      var bar = drawer.querySelector('.lovendi-fsbar');
      if(!bar){
        bar = document.createElement('div');
        bar.className = 'lovendi-fsbar';
        bar.innerHTML = '<p class="lovendi-fsbar__txt"></p><div class="lovendi-fsbar__track"><div class="lovendi-fsbar__fill"></div></div>';
        contents.parentNode.insertBefore(bar, contents);
      }
      var total = cart.total_price || 0;
      var pct = Math.max(0, Math.min(1, total / THRESHOLD));
      bar.querySelector('.lovendi-fsbar__fill').style.width = (pct*100) + '%';
      var txt = bar.querySelector('.lovendi-fsbar__txt');
      if(total >= THRESHOLD){ txt.innerHTML = '✓ Odblokowałeś darmową dostawę!'; bar.classList.add('is-done'); }
      else { txt.innerHTML = 'Dodaj jeszcze <strong>' + money(THRESHOLD - total) + '</strong>, aby mieć darmową dostawę'; bar.classList.remove('is-done'); }
    }
    function renderExtra(){
      var ctas = drawer.querySelector('.cart__ctas');
      if(!ctas || drawer.querySelector('.lovendi-cart-extra')) return;
      var box = document.createElement('div');
      box.className = 'lovendi-cart-extra';
      box.innerHTML = '<div class="lovendi-cart-safe"><svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="2"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg> Bezpieczna płatność</div><div class="lovendi-cart-pay"><span>BLIK</span><span>Przelewy24</span><span>Visa</span><span>Mastercard</span><span>Apple Pay</span><span>Google Pay</span></div>';
      ctas.appendChild(box);
    }
    var t;
    function refresh(){
      clearTimeout(t);
      t = setTimeout(function(){
        fetch('/cart.js', {headers:{'Accept':'application/json'}})
          .then(function(r){ return r.json(); })
          .then(function(cart){ renderBar(cart); renderExtra(); })
          .catch(function(){});
      }, 180);
    }
    refresh();
    new MutationObserver(refresh).observe(drawer, {childList:true, subtree:true});
    document.addEventListener('click', function(e){
      if(e.target.closest('#cart-icon-bubble, .header__icon--cart, a[href$="/cart"]')) refresh();
    });
  }

  function initCartContinue(){
    var PROD = '/products/lovendi-kaptur-wyciszajacy-dla-psa';
    document.addEventListener('click', function(e){
      var t = e.target;
      if(!t || !t.closest) return;
      var a = t.closest('a[href*="/collections/all"]');
      if(!a) return;
      if(a.closest('cart-items, cart-drawer, #CartDrawer, .cart__warnings, .cart-drawer__warnings, .drawer')){
        e.preventDefault();
        window.location.href = PROD;
      }
    });
  }

  function init(){ initBackTop(); initSticky(); initPayUnderAtc(); initDelivery(); initBaSlider(); initTabs(); initBuilder(); initRating(); initCartExtras(); initCartContinue(); }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
})();
